<section class="qf" role="search">

  <header class="qf__head">
    <h2 class="qf__title">
      <i class="fa-solid fa-filter" aria-hidden="true"></i>
      {{ 'QUESTION_BANK.FILTERS.TITLE' | translate }}
      @if (hasActiveFilters()) {
        <span class="qf__count">
          {{ 'QUESTION_BANK.FILTERS.ACTIVE_COUNT' | translate: { count: activeCount() } }}
        </span>
      }
    </h2>

    @if (hasActiveFilters()) {
      <button type="button" class="qf__reset" (click)="reset()">
        <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.FILTERS.RESET' | translate }}
      </button>
    }
  </header>

  <!-- Recherche libre : débouncée, une requête par pause de frappe. -->
  <div class="qf__search">
    <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
    <input type="search"
           [value]="textDraft()"
           (input)="onText($any($event.target).value)"
           [attr.aria-label]="'QUESTION_BANK.FILTERS.SEARCH' | translate"
           [placeholder]="'QUESTION_BANK.FILTERS.SEARCH_PLACEHOLDER' | translate">
  </div>

  <!-- Référentiel indisponible : facettes désactivées, aucune option inventée. -->
  @if (taxonomyErrored()) {
    <p class="qf__notice" role="status">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <span>{{ 'QUESTION_BANK.FILTERS.TAXONOMY_ERROR' | translate }}</span>
      <button type="button" class="qf__notice-btn" (click)="reloadTaxonomy.emit()">
        {{ 'COMMON.RETRY' | translate }}
      </button>
    </p>
  }

  <div class="qf__grid">

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.LEARNING_PATH' | translate }}</span>
      <select [value]="value.learningPathId ?? ''"
              [disabled]="taxonomyErrored() || learningPaths().length === 0"
              (change)="onLearningPath($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_LEARNING_PATHS' | translate }}</option>
        @for (p of learningPaths(); track p.id) {
          <option [value]="p.id">{{ p.title }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.SUBJECT' | translate }}</span>
      <select [value]="value.subjectId ?? ''"
              [disabled]="taxonomyErrored() || visibleSubjects().length === 0"
              (change)="onSubject($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_SUBJECTS' | translate }}</option>
        @for (s of visibleSubjects(); track s.id) {
          <option [value]="s.id">{{ subjectLabel(s) }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.THEME' | translate }}</span>
      <select [value]="value.themeId ?? ''"
              [disabled]="taxonomyErrored() || visibleThemes().length === 0"
              (change)="onTheme($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_THEMES' | translate }}</option>
        @for (t of visibleThemes(); track t.id) {
          <option [value]="t.id">{{ t.title }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.TYPE' | translate }}</span>
      <select [value]="value.questionType ?? ''"
              (change)="onType($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_TYPES' | translate }}</option>
        @for (t of questionTypes; track t) {
          <option [value]="t">{{ labelKey('TYPE', t) | translate }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.DIFFICULTY' | translate }}</span>
      <select [value]="value.difficultyLevel ?? ''"
              (change)="onDifficulty($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_DIFFICULTIES' | translate }}</option>
        @for (d of difficultyLevels; track d) {
          <option [value]="d">{{ labelKey('DIFFICULTY', d) | translate }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.STATUS' | translate }}</span>
      <select [value]="value.status ?? ''"
              (change)="onStatus($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_STATUSES' | translate }}</option>
        @for (s of statuses; track s) {
          <option [value]="s">{{ labelKey('STATUS', s) | translate }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.ORIGIN' | translate }}</span>
      <select [value]="value.origin ?? ''"
              (change)="onOrigin($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_ORIGINS' | translate }}</option>
        @for (o of origins; track o) {
          <option [value]="o">{{ labelKey('ORIGIN', o) | translate }}</option>
        }
      </select>
    </label>

    <label class="qf__field">
      <span class="qf__label">{{ 'QUESTION_BANK.FILTERS.LANGUAGE' | translate }}</span>
      <select [value]="value.language ?? ''"
              (change)="onLanguage($any($event.target).value)">
        <option value="">{{ 'QUESTION_BANK.FILTERS.ALL_LANGUAGES' | translate }}</option>
        @for (l of languages; track l) {
          <option [value]="l">{{ labelKey('LANGUAGE', l) | translate }}</option>
        }
      </select>
    </label>

    <label class="qf__toggle">
      <input type="checkbox"
             [checked]="!!value.includeArchived"
             (change)="onIncludeArchived($any($event.target).checked)">
      <span>{{ 'QUESTION_BANK.FILTERS.INCLUDE_ARCHIVED' | translate }}</span>
    </label>

  </div>
</section>
